import styled from '@emotion/styled';

const StyledBanner = styled.div`
    .banner-container {
        background-color: #002B45;
        padding-top: 1rem;
        padding-bottom: 1rem;
        color: #FFF;
        font-size: 15px;
        font-family: 'dfds-light';
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;

        .container {
            display: flex;
        }

        .left {
            width: 70%;
            float: left;
            display: flex;

            a {
                text-decoration: underline;
                color: #fff;
            }

            span svg {
                height: 20px;
                width: 20px;
            }

            .icon {
                display: flex;
                align-items: center;
                margin-right: 0.5rem;

                svg {
                    height: 20px;
                    width: 20px;
                }
            }
        }

        .icon {
            display: flex;
            padding-right: 0.5rem;

            svg {
                height: 20px;
                width: 20px;
                }
        }

        .right {
            width: 30%;
            float: right;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .button {
                font-size: 16px;
                padding: 3px 20px;
                background-color: #002B45;
                border: 1px solid #66B0E0;
                color: #66B0E0;
                border-radius: 2px;
                margin-left: 1rem;
            }

            .button:hover {
                color: #ffffff;
                border: 1px solid #ffffff;
            }

            .cross {
                color: #fff;
                display: flex;
                align-items: center;
            }
        }

        .under {
            padding-top: 1rem;
            width: 100%;
            display: none;

            .button {
                border: 1px solid #fff;
                padding: 0.4rem;
                padding-left: 0.7rem;
                padding-right: 0.7rem;
                text-decoration: none;
                color: #fff;
            }

            .button:hover {
                color: #ffffff;
                border: 1px solid #ffffff;
            }
        }

        @media screen and (max-width: 1000px) {
            .banner-container {
                .container {
                    display: block;
                }
            }

            .desktop {
                display: none;
            }

            .under {
                padding-top: 1rem;
                display: block;
                margin-left: 1.7rem;

                .button {
                    display: initial;
                    font-size: 16px;
                    padding: 3px 20px;
                    background-color: #002B45;
                    border: 1px solid #66B0E0;
                    color: #66B0E0;
                    border-radius: 2px;
                    margin-left: 1rem;
                }
            }

            .left {
                width: 95%;
            }

            .right {
                width: 5%;
            }
        }
    }

    .break {
        clear:both;
    }

    .banner-padding {
        padding-left: 0.83333rem;
        padding-right: 0.83333rem;
    }

    @media only screen and (min-width: 78.063em) {
        .banner-padding {
            padding-left: 0;
            padding-right: 0;
        }
    }

    @media only screen and (max-width: 40.063em) {
        .banner-padding {
            padding-left: 0;
            padding-right: 0;
        }
    }
`

export default StyledBanner
